import {
  Box,
  Button,
  Grid,
  TextField,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Modal,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import "./Fpm.css";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  setBnkState,
  setCoopState,
  setMicroState,
  setLFState,
  setIMState,
  setDigiState,
  setMAState,
} from "../features/fpmSlice/FmpSlice";
import { CloseRounded } from "@mui/icons-material";
import * as FirestoreService from "../utils/firestoreQuery";
import Logo from "../images/logo_quick-learning-tool.png";
import Swal from "sweetalert2";

function FpmPage3Fil() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  let TRows = [];
  let TTextBnk = [];
  let TTextCoop = [];
  let TTextMicro = [];
  let TTextLF = [];
  let TTextIM = [];
  let TTextMA = [];
  let TTextDigi = [];
  const [myArray, setMyArray] = useState([]);
  const [anti, setAnti] = useState(0);
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);
  const [tableGuide, setTableGuide] = useState();
  const [openSample, setOpenSample] = useState(false);
  const handleOpenSample = () => setOpenSample(true);
  const handleCloseSample = () => setOpenSample(false);

  const {
    sCheck1,
    sCheck2,
    sCheck3,
    sCheck4,
    sCheck5,
    sCheck6,
    sCheck7,
    sCheck8,
    sCheck9,
    sCheck9Text,
    fspType,
    q3Check1,
    q3Check2,
    q3Check3,
    q3Check4,
    q3Check5,
    q3Check6,
    q3Check7,
    lCheck1,
    lCheck2,
    lCheck3,
    lCheck4,
    lCheck5,
    lCheck6,
    lCheck7,
    lCheck8,
    lCheck9,
    lCheck10,
    lCheck11,
    iCheck1,
    iCheck2,
    iCheck3,
    iCheck4,
    iCheck5,
    iCheck6,
    iCheck7,
    iCheck8,
    iCheck9,
    iCheck10,
    iCheck11,
  } = useSelector((state) => state.fpm);

  const handleContinue = () => {
    if (q3Check1 === true) {
      if (TTextBnk.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("1");
        return;
      }
    }
    if (q3Check2 === true) {
      if (TTextCoop.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("2");
        return;
      }
    }
    if (q3Check3 === true) {
      if (TTextMicro.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("3");
        return;
      }
    }
    if (q3Check4 === true) {
      if (TTextLF.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("4");
        return;
      }
    }
    if (q3Check5 === true) {
      if (TTextIM.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("5");
        return;
      }
    }
    if (q3Check6 === true) {
      if (TTextDigi.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("6");
        return;
      }
    }
    if (q3Check7 === true) {
      if (TTextMA.length !== myArray.length) {
        Swal.fire({
          icon: "error",
          title: "Hindi kumpletong patlang",
          text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
          customClass: {
            popup: "custom-swal-popup",
            confirmButton: "custom-swal-button",
          },
        });
        console.log("7");
        return;
      }
    }

    const arrays = [
      TTextBnk,
      TTextCoop,
      TTextMicro,
      TTextLF,
      TTextIM,
      TTextMA,
      TTextDigi,
    ];

    const hasEmptyString = arrays.some((arr) =>
      arr.some((item) => item === "")
    );

    if (hasEmptyString) {
      Swal.fire({
        icon: "error",
        title: "Hindi kumpletong patlang",
        text: "Pakikumpleto ang lahat ng kinakailangang patlang para magpatuloy",
        customClass: {
          popup: "custom-swal-popup",
          confirmButton: "custom-swal-button",
        },
      });
      console.log("Blank");
      return;
    }

    dispatch(setBnkState(TTextBnk));
    dispatch(setCoopState(TTextCoop));
    dispatch(setMicroState(TTextMicro));
    dispatch(setLFState(TTextLF));
    dispatch(setIMState(TTextIM));
    dispatch(setMAState(TTextMA));
    dispatch(setDigiState(TTextDigi));
    navigate("/page4/Fil");
  };

  const handleBack = () => {
    navigate("/page2/Fil");
  };

  const handleTableTextBnk = (value, index) => {
    TTextBnk[index] = value;
  };

  const handleTableTextCoop = (value, index) => {
    TTextCoop[index] = value;
  };

  const handleTableTextMicro = (value, index) => {
    TTextMicro[index] = value;
  };

  const handleTableTextLF = (value, index) => {
    TTextLF[index] = value;
  };

  const handleTableTextIM = (value, index) => {
    TTextIM[index] = value;
  };

  const handleTableTextMA = (value, index) => {
    TTextMA[index] = value;
  };

  const handleTableTextDigi = (value, index) => {
    TTextDigi[index] = value;
  };

  const savingsTableData = () => {
    if (sCheck1 === true) {
      TRows = [...TRows, "Inisyal na deposito para magbukas ng account (PHP)"];
    }
    if (sCheck2 === true) {
      TRows = [
        ...TRows,
        "Kinakailangang dokumento o kondisyon para magbukas ng account",
      ];
    }
    if (sCheck3 === true) {
      TRows = [...TRows, "Balance na kailangang mapanatili (PHP"];
    }
    if (sCheck4 === true) {
      TRows = [...TRows, "Interes sa deposito (% kada taon)"];
    }
    if (sCheck5 === true) {
      TRows = [...TRows, "Halaga ng deposito upang kumita ng interes (PHP)"];
    }
    if (sCheck6 === true) {
      TRows = [...TRows, "Proseso ng pagwi-withdraw"];
    }
    if (sCheck7 === true) {
      TRows = [...TRows, "Insurance sa deposito"];
    }
    if (sCheck8 === true) {
      TRows = [...TRows, "Bayarin at singil (PHP)"];
    }
    if (sCheck9 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    setMyArray(TRows);
    setAnti(1);
  };

  const loansTableData = () => {
    if (lCheck1 === true) {
      TRows = [...TRows, "Halaga ng loan (PHP)"];
    }
    if (lCheck2 === true) {
      TRows = [
        ...TRows,
        "Kinakailangang dokumento o kondisyon para makakuha ng loan",
      ];
    }
    if (lCheck3 === true) {
      TRows = [
        ...TRows,
        "Bundled o pinagsamang produktong pinansyal (hal. savings, insurance)",
      ];
    }
    if (lCheck4 === true) {
      TRows = [
        ...TRows,
        "Paraan ng pagbabayad at regular na halagang prinsipal (hal. PHP 1,000 kada buwan)",
      ];
    }
    if (lCheck5 === true) {
      TRows = [...TRows, "Rate ng interes (% kada buwan)"];
    }
    if (lCheck6 === true) {
      TRows = [...TRows, "Effective Interest Rate (EIR, % kada taon)"];
    }
    if (lCheck7 === true) {
      TRows = [...TRows, "Iba pang bayarin at singil (PHP)"];
    }
    if (lCheck8 === true) {
      TRows = [
        ...TRows,
        "Pinagsamang hindi pinansyal na mga produkto nang walang bayad sa mga kliyente (hal. financial education, skills training, atbp.)",
      ];
    }
    if (lCheck9 === true) {
      TRows = [...TRows, "Collateral"];
    }
    if (lCheck10 === true) {
      TRows = [...TRows, "Kondisyon ng pagbabayad"];
    }
    if (lCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    console.log(lCheck11);

    setMyArray(TRows);
    setAnti(1);
  };

  const insuranceTableData = () => {
    if (iCheck1 === true) {
      TRows = [...TRows, "Kabuuang premium na dapat bayaran (PHP)"];
    }
    if (iCheck2 === true) {
      TRows = [...TRows, "Delivery channel - para mag-claim"];
    }
    if (iCheck3 === true) {
      TRows = [...TRows, "Kondisyon ng pagbabayad"];
    }
    if (iCheck4 === true) {
      TRows = [
        ...TRows,
        "Paraan ng pagbabayad at halaga ng premium sa installment",
      ];
    }
    if (iCheck5 === true) {
      TRows = [
        ...TRows,
        "Kinakailangang dokumento o kondisyon para makakuha ng policy",
      ];
    }
    if (iCheck6 === true) {
      TRows = [
        ...TRows,
        "Delivery channel - para bumili ng isang insurance policy",
      ];
    }
    if (iCheck7 === true) {
      TRows = [
        ...TRows,
        "Delivery channel - para bayaran ang regular na premium",
      ];
    }
    if (iCheck8 === true) {
      TRows = [...TRows, "Sakop na halaga"];
    }
    if (iCheck9 === true) {
      TRows = [
        ...TRows,
        "Kinakailangang dokumento o kondisyon para mag-file ng claim",
      ];
    }
    if (iCheck10 === true) {
      TRows = [...TRows, "Karaniwang bilang ng araw upang ayusin ang claim"];
    }
    if (iCheck11 === true) {
      TRows = [...TRows, sCheck9Text];
    }

    setMyArray(TRows);
    setAnti(1);
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (fspType === "Savings") {
      savingsTableData();
    }
    if (fspType === "Loans") {
      loansTableData();
    }
    if (fspType === "Insurance") {
      insuranceTableData();
    }

    FirestoreService.getFPMAssests().onSnapshot((doc) => {
      setTableGuide(doc.data().fpmAssets.page3Popup);
    });
  }, [anti]);

  return (
    <Box className="Main__Card__FPM">
      <Grid container>
        <Grid Item xs={12} md={3} className="left-card">
          <Box className="new-logo-container">
            <img src={Logo} alt="logo" className="new-logo-img" />
          </Box>
          <Box sx={{ marginBottom: "1rem" }}>
            <Button className="fpm--button" onClick={() => navigate("/")}>
              To English Ver.
            </Button>
          </Box>
          <Box className="instruction-card">
            <p className="instruction-title">Gabay</p>
            <p className="instruction-text">
              Pumili ng Angkop na Produkto at Tagapagbigay ng Serbisyong
              Pinansyal.
            </p>
            <p className="instruction-text">
              Ang isang customer na may kakayahan ay alam kung aling mga feature
              ng produkto ang akma sa kanyang mga pangangailangan at kondisyon
              at kayang magkumpara ng mga feature ng produkto sa pagitan ng 2-4
              Financial Service Providers (FSPs) na aktibo sa lugar.
            </p>
            <p className="instruction-text">
              Sa bahaging ito, ibinibigay ang mga ehersisyo upang muling
              pabanguhin ang customer tungkol sa iba't ibang uri ng FSPs at ang
              mga feature ng produkto na dapat isaalang-alang sa bawat napiling
              produktong pinansyal. Isang tool na tinatawag na Financial Product
              Matrix (FPM) ay magagamit upang tulungan na organisahin ang
              impormasyon ng produkto na magpapadali sa paghahambing at
              pagraranggo sa pagitan ng FSPs batay sa partikular na mga
              kagustuhan ng customer.
            </p>
          </Box>
        </Grid>
        <Grid Item xs={12} md={9} className="right-card">
          <Box className="fpm__card">
            <Box className="fpm--opening--text1" sx={{ textAlign: "center" }}>
              <p>
                Ikumpara at Rangkahan ang Mga Feature ng Produkto sa Pagitan ng
                mga Financial Service Providers (FSP)
              </p>
            </Box>
            <Box className="child-card">
              <p>
                Susunod, punan natin kung ano mayroon. Maaring magtanong ka sa
                iyong lugar para sa mga sumusunod na detalye. Pagkatapos mong
                punan ang lahat ng mga detalye, magpatuloy tayo sa susunod na
                pahina.
              </p>
              <Box className="scrollable-table">
                <TableContainer className="fpm---table---container">
                  <Table size="small" className="fpm---table">
                    <TableHead>
                      <TableRow className="fpm---table---header2">
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                        >
                          {fspType}
                        </TableCell>
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                          colSpan="100%"
                        >
                          Financial Service Provider (FSP)
                        </TableCell>
                      </TableRow>
                      <TableRow className="fpm---table---header">
                        <TableCell
                          className="fpm---table---cell2"
                          align="center"
                        >
                          Product Terms
                        </TableCell>
                        {q3Check1 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Bank
                          </TableCell>
                        ) : null}
                        {q3Check2 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Cooperatives
                          </TableCell>
                        ) : null}
                        {q3Check3 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Microfinance NGOs
                          </TableCell>
                        ) : null}
                        {q3Check4 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Lending and Finance Companies
                          </TableCell>
                        ) : null}
                        {q3Check5 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Insurance Companies
                          </TableCell>
                        ) : null}
                        {q3Check7 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Mutual Benefit Associations
                          </TableCell>
                        ) : null}
                        {q3Check6 === true ? (
                          <TableCell
                            className="fpm---table---cell2"
                            align="center"
                          >
                            Digital FPS
                          </TableCell>
                        ) : null}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {myArray.map((row, index) => (
                        <TableRow key={index}>
                          <TableCell className="fpm---table---cell1">
                            {row}
                          </TableCell>
                          {q3Check1 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextBnk(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check2 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextCoop(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check3 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextMicro(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check4 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextLF(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check5 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextIM(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check7 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextMA(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                          {q3Check6 === true ? (
                            <TableCell className="fpm---table---cell">
                              <TextField
                                onChange={(e) =>
                                  handleTableTextDigi(e.target.value, index)
                                }
                                sx={{ width: "9rem" }}
                                variant="standard"
                                InputProps={{ disableUnderline: true }}
                              />
                            </TableCell>
                          ) : null}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Box>
            </Box>
            <Box>
              <Grid container>
                <Grid
                  item
                  xs={12}
                  md={6}
                  sx={{
                    display: "flex",
                    justifyContent: "flex-start",
                    alignItems: "center",
                  }}
                >
                  <p className="link-text" onClick={() => handleOpenSample()}>
                    Tingnan ang halimbawa ng FPM Table
                  </p>
                </Grid>
                <Grid item xs={12} md={6} className="left-card">
                  <Box
                    className="fpm__button__container"
                    sx={{
                      display: "flex",
                      gap: "1rem",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      className="fpm--button-2"
                      onClick={() => handleBack()}
                    >
                      Bumalik
                    </Button>
                    <Button
                      className="fpm--button"
                      onClick={() => handleContinue()}
                      sx={{ width: "50%" }}
                    >
                      Sunod
                    </Button>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          </Box>
        </Grid>
      </Grid>

      <Modal open={openSample} onClose={handleCloseSample}>
        <Box className="fpm__modal2">
          <Box className="fpm--modal--text">
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <CloseRounded
                className="fpm--modal--iconButton"
                onClick={() => handleCloseSample()}
              />
            </Box>
            <Box className="table-img-container">
              <img
                src={tableGuide}
                alt="Table"
                style={{ width: "100%", objectFit: "cover" }}
              />
            </Box>
          </Box>
        </Box>
      </Modal>

      <Modal open={open} onClose={handleClose}>
        <Box className="fpm__modal2">
          <Box className="fpm--modal--text">
            <Box
              sx={{
                display: "flex",
                justifyContent: "flex-end",
                alignItems: "center",
              }}
            >
              <CloseRounded
                className="fpm--modal--iconButton"
                onClick={() => handleClose()}
              />
            </Box>
            <Box
              sx={{
                marginTop: "1rem",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                flexDirection: "column",
              }}
            >
              <h1 style={{ marginBottom: "1rem" }}>Congratulations!</h1>
              <p style={{ fontSize: "1.5rem" }}>
                Na-set up mo na ang iyong Financial Product Matrix (FPM)
              </p>
            </Box>
          </Box>
        </Box>
      </Modal>
    </Box>
  );
}

export default FpmPage3Fil;
